import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { FormField } from '../../../../components/form/FormField';
import { fieldValidators } from '../../../../helpers/fieldValidators';
import { Loader } from '../../../../components/Loader';
import { fieldNormalizers } from '../../../../helpers/fieldNormalizers';

let CoefficientForm = props => {
  const { error, handleSubmit, submitting, currentItem } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Field
        name="title"
        type="text"
        label="Название"
        validate={[fieldValidators.required]}
        component={FormField}
        disabled="disabled"
      />
      <Field
        name="value"
        type="text"
        label="Значение коэффициента"
        validate={[fieldValidators.required]}
        component={FormField}
        normalize={fieldNormalizers.number}
      />
      <Field
        name="spring_value"
        type="text"
        label="Значение коэффициента (весна)"
        validate={[fieldValidators.required]}
        component={FormField}
        normalize={fieldNormalizers.number}
      />

      {error && <strong>{error}</strong>}
      <div>
        {submitting && <Loader />}
        <button type="submit" className="btn" disabled={submitting}>
          {currentItem ? 'Редактировать' : 'Создать'}
        </button>
      </div>
    </form>
  );
};

CoefficientForm = reduxForm({
  form: 'coefficient-form',
  enableReinitialize: true
})(CoefficientForm);

CoefficientForm = connect(state => ({
  initialValues: {
    id: state.coefficients.currentItem ? state.coefficients.currentItem.id : '',
    title: state.coefficients.currentItem ? state.coefficients.currentItem.title : '',
    short_title: state.coefficients.currentItem ? state.coefficients.currentItem.short_title : '',
    value: state.coefficients.currentItem ? state.coefficients.currentItem.value : '',
    spring_value: state.coefficients.currentItem ? state.coefficients.currentItem.spring_value : ''
  }
}))(CoefficientForm);

export default CoefficientForm;
